import styled from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.div`
  display: flex;
  max-width: 1160px;
  margin: 0 0 40px 0;
  flex: 0;

  ${breakpoint('base', 'xl')`
    flex-wrap: wrap;
  `}
`

export const Icon = styled.svg`
  width: 48px;
  height: 48px;
`
